import api from './api';

export const getCommerceDetails = async (comercioKey: string) => {
  try {
    const response = await api.get(`/comercios/${comercioKey}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching details for commerce ${comercioKey}:`, error);
    throw error;
  }
};